<template>
	<SuiSelectListButton
		:aria-selected="isSelected"
		:aria-label="role.name"
		:active="isSelected"
		:data-index="dataIndex"
		class="user-assign-select-role-item"
		:class="classAddons"
		@click="$emit('click', role)"
	>
		<SuiAvatar
			size="x-small"
			variant="dashed"
			show-border
			:name="role?.name"
			:initials="role.initials ?? ''"
			:color="role.hslColor ?? ''"
			class="user-assign-select-role-item__avatar"
		/>
		<p class="user-assign-select-role-item__name">
			{{ role?.name }}
		</p>
		<SuiIcon
			v-if="isSelected"
			name="icon-tick-16"
			class="user-assign-select-role-item__tick"
		/>
	</SuiSelectListButton>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { SuiSelectListButton, SuiIcon, SuiAvatar } from '@developers/scoro-ui';
import type { UserAssignSelectRole } from '../../../types';

export interface UserAssignSelectListRoleItemProps {
	role: UserAssignSelectRole;
	isSelected: boolean;
	dataIndex?: number;
}

const { isSelected, dataIndex = undefined } =
	defineProps<UserAssignSelectListRoleItemProps>();

defineEmits<{
	click: [role: UserAssignSelectRole];
}>();

const classAddons = computed(() => ({
	'user-assign-select-role-item--selected': isSelected,
}));
</script>

<style scoped lang="scss">
.user-assign-select-role-item {
	&__name {
		flex: 1;
	}

	&__tick {
		--sui-icon-fill: #{$blue-50};

		margin-left: auto;
	}
}
</style>
